import React from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
import { useLocation } from 'react-router-dom'

import ImgBox from '../../components/Gamification/ImgBox'
import ExchangeNft from '../../components/Gamification/ExchangeNft'
import { RowColumn } from '../../components/Row'

import { NFTTYPE } from '../../constants/bakery/nft'

const SoccerMain = styled.div`
  width: 890px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 100%;
  `};
`
const Main = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`
const activeClassName = 'ACTIVENAV'

const AutoRowColumn = styled(RowColumn)`
  height: 543px;
`

export const Info = styled.div`
    color: ${({ theme }) => theme.bsText7};
    width: 432px;
    height: auto;
    flex: 1;
    margin-top: 25px;
    overflow-y: scroll;
    padding: 16px 30px;
    border-radius: 20px;
    background: ${({ theme }) => theme.bsBg2};
    ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 90%;
    height: auto;
    margin: 0 auto;
    margin-bottom: 20px;
    `};
`


export default function Soccer () {
  const location = useLocation()
  return (
    <SoccerMain>
      <Main>
        <ImgBox imgLink={'/images/nft/gam-equipments.png'}/>
        <AutoRowColumn>
          <ExchangeNft type={NFTTYPE.EQUIPMENT} />
          <Info className={location.pathname.indexOf('gamification/equipment') > -1 ? activeClassName : ''}>
            <Text fontSize={18} fontFamily={'Baloo Da'} fontWeight={700}>The time to add more customization to your Doggy or Barking Sound NFT has come!</Text>
            <Text fontSize={14} marginTop={20}>In this new cryptodoggies' game upgrade with these shiny pieces of equipment, you will be able to make your game characters more lovely and enjoy a better gaming experience.</Text>
            <Text fontSize={14} marginTop={20}>Besides, all the $DOGGY spent this way will be burned, thus helping to reduce the Total Supply of the $DOGGY token. This includes both the 100% purchase from this Equipment shop and the 5% NFT Supermarket fee. Yes! You will be able to sell the equipment to other players on the BakerySwap marketplace.</Text>
            <Text fontSize={14} marginTop={20}>There are a total of 43,200 available pieces of equipment for the Cryptodoggies NFTs and they are divided into four groups with 10,800 in each of the groups.</Text>
            <Text fontSize={14} marginTop={20}>At the same time, each type is divided into 3 styles, with 3,600 pieces. </Text>
            <Text fontSize={14} marginTop={20}>The cost of one of these pieces of equipment is 100,000 Doggy. Get one now to improve your experience or stake it to get $BAKE. Equipment NFTs are also gamified finance item! So you choose to buy, play, trade, or stake it!</Text>
          </Info>
        </AutoRowColumn>
      </Main>
    </SoccerMain>
  )
}